import { LocalDate } from '@js-joda/core';

import { ModalConfirmButton } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../translations';
import { usePrivateIndividualInvoiceCreateCommand } from '../PrivateIndividualInvoiceCreateModalConfirmButton.hooks';
import { InvoiceCreateFormController } from '../form/InvoiceCreateForm.types';
import { InvoicePaymentMethod } from '../../types';

import { usePrivateIndividualInvoiceCreateWithReceiptCommand } from './PrintReceiptAndCreateInvoiceModalConfirmButton.hooks';

type PrintReceiptAndCreateInvoiceModalConfirmButtonProps = Pick<InvoiceCreateFormController, 'handleSubmit'> & {
   readonly onSuccess: VoidFunction;
   readonly paymentMethod: InvoicePaymentMethod;
   readonly visitDate: LocalDate;
   readonly visitSettlementId: number;
};

export const PrintReceiptAndCreateInvoiceModalConfirmButton = (
   props: PrintReceiptAndCreateInvoiceModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: createPrivateIndividualInvoice } = usePrivateIndividualInvoiceCreateCommand({
      onSuccess: props.onSuccess,
      paymentMethod: props.paymentMethod,
      visitDate: props.visitDate,
      visitSettlementId: props.visitSettlementId,
      receiptAvailableForInvoice: true,
   });
   const {
      executeAsync: createPrivateIndividualInvoiceWithReceipt,
   } = usePrivateIndividualInvoiceCreateWithReceiptCommand({
      onSuccess: createPrivateIndividualInvoice,
      visitDate: props.visitDate,
      visitSettlementId: props.visitSettlementId,
      paymentMethod: props.paymentMethod,
   });

   return (
      <ModalConfirmButton
         testId={'printReceipt'}
         label={invoiceCreateModalTranslationKeys.withReceipt.printReceipt}
         onClick={props.handleSubmit(createPrivateIndividualInvoiceWithReceipt)}
      />
   );
};
